import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {IfAuthorizedVisualisationDirective} from './directives/if-authorized-visualisation.directive';
import {IfAuthorizedSuppressionDirective} from './directives/if-authorized-suppression.directive';
import {IfAuthorizedEditionDirective} from './directives/if-authorized-edition.directive';
import {IfAuthorizedActifDirective} from './directives/if-authorized-actif.directive';
import {IfAuthorizedExportDirective} from './directives/if-authorized-export.directive';

@NgModule({
  declarations: [
    IfAuthorizedVisualisationDirective,
    IfAuthorizedSuppressionDirective,
    IfAuthorizedEditionDirective,
    IfAuthorizedActifDirective,
    IfAuthorizedExportDirective,
  ],
  imports: [CommonModule],
  exports: [
    IfAuthorizedVisualisationDirective,
    IfAuthorizedSuppressionDirective,
    IfAuthorizedEditionDirective,
    IfAuthorizedActifDirective,
    IfAuthorizedExportDirective,
  ],
})
export class SecurityCommonModule {}
